<script lang="ts" setup>
import {useFetchGeneralSummary} from '~/api/service/general/summary/index.service'
import GeneralSummary from '~/components/summary/GeneralSummary.vue'
import {HOME_CHART_TOOLTIP} from '~/constants/general.const'
import {IMAGE_BASE_URL} from '~/constants/image.constant'
import BcSearchInput from '~/ui/Input/BcSearchInput.vue'
import BcKeyboard from '~/ui/Keyboard/BcKeyboard.vue'
import {getSearchInputKey} from '~/utils/osType'
import { UNIT } from '~/environment-variables/unit.const'

const route = useRoute()

const {data} = useFetchGeneralSummary()

const {changeShowModal} = useModal()
</script>

<template>
  <nav class="top-navbar">
    <h1 class="logo">
      <NuxtLink
        :to="routes.getRootPage()"
        class="block h-full w-fit"
      >
        <img
          :src="`${IMAGE_BASE_URL}/logo/logo_mainnet.png`"
          alt="maplestory universe explorer"
          width="200"
        >
      </NuxtLink>
    </h1>
    <div class="search-summary">
      <BcSearchInput
        @click="changeShowModal()"
        class="max-w-[728px]"
        type="general"
        readonly
      >
        <template #suffix>
          <BcKeyboard
            v-if="getSearchInputKey()"
            :value="getSearchInputKey()"
          />
        </template>
      </BcSearchInput>
      <ul
        v-if="data"
        class="ml-auto flex justify-end"
      >
      <GeneralSummary
          :name="`${UNIT} Price`"
          :value="data.price"
          :percentage="data.price24h"
          :img="`${IMAGE_BASE_URL}/token/nexpace.png`"
          color="text-white"
        />
        <GeneralSummary
          name="Gas Tracker"
          :value="data.gasTracker"
          icon="gas-pump"
          color="text-explorer-blue"
          :tooltip="HOME_CHART_TOOLTIP.SUMMARY.gasTracker"
        />
      </ul>
    </div>
  </nav>
</template>

<style scoped lang="scss">
.top-navbar {
  @apply w-full flex items-center bg-background h-16;

  .logo {
    @apply box-border w-72 pl-4 bg-transparent shrink-0;

    @include md {
      width: 196px;
    }
  }

  .search-summary {
    @apply py-4 flex grow justify-evenly gap-x-8 px-16;

    @include md {
      @apply px-8;
    }
  }
}
</style>